import ReactDOM from 'react-dom';
import { Widget } from './Widget';

// TODO: When we introduce proper SSR it might make sense to dynamically load the widget

declare global {
    interface Window {
        RWL_INITIAL_STATE?: {
            accountId: string;
            apiBaseUrl: string;
            config?: any;
            brandColor?: string;
            sentryEnvironment?: string;
        };
    }
}

if (window.RWL_INITIAL_STATE) {
    const { accountId, apiBaseUrl, config, brandColor, sentryEnvironment } =
        window.RWL_INITIAL_STATE;

    if (!config) {
        console.warn('Config was not provided, will fetch from server instead');
    }

    ReactDOM.render(
        <Widget
            accountId={accountId}
            apiBaseUrl={apiBaseUrl}
            config={config}
            brandColor={brandColor}
            sentryEnvironment={sentryEnvironment}
        />,
        document.getElementById('rwl-salestool-root')
    );
} else {
    console.error('No initial state found');
}
